// Wash & Dry Station - Main cleaning operations department
import React from 'react';
import { RefreshCw } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const WashDryStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="wash-dry"
      stationName="Wash & Dry"
      stationIcon={<RefreshCw className="w-6 h-6" />}
      stationColor="#10B981"
      showAdvanceButton={true}
      showCustomerContact={false}
      showDeliveryInfo={false}
    />
  );
};

export default WashDryStation;
